import { createContext } from 'react';
export const LeadsListContext = createContext(null);
